import React      from 'react';
import { Header } from "semantic-ui-react";

import { DecisionPointDefinition, DecisionPointDialog, DecisionPointDialogProps } from "@src/views/components/modals/DecisionPointDialog";
import { FinePrintMessage }                                                       from "@src/views/components/util/messaging/FinePrintMessage";


export enum CorvalAssistantContextDecisionPointTypes {
    MANAGED   = 1,
    UNMANAGED = 2,
}

interface CorvalAssistantContextUpdateDecisionPointDialogProps extends Omit<DecisionPointDialogProps<CorvalAssistantContextDecisionPointTypes>, 'dialogTitle' | 'decisionOptions'> {
    isCorvalManaged: boolean,
}

const CorvalAssistantContextUpdateDecisionPointDialogDefaultProps = {
    isCorvalManaged: false,
} satisfies Partial<CorvalAssistantContextUpdateDecisionPointDialogProps>

function CorvalAssistantContextUpdateDecisionPointDialog( p: CorvalAssistantContextUpdateDecisionPointDialogProps ){

    const props = { ...CorvalAssistantContextUpdateDecisionPointDialogDefaultProps, ...p };

    const CorvalAssistantContextGuidanceOptions = new Map<CorvalAssistantContextDecisionPointTypes, DecisionPointDefinition>( [
        [ CorvalAssistantContextDecisionPointTypes.MANAGED, {
            title:       `Use Corval Assistant`,
            description: `Corval Assistant helps manage your project activities, timing, and resources.`,
            icon:        { name: 'compass' },
            details:     (
                             <>
                                 <Header size={ 'small' }>Corval Assistant</Header>
                                 <p>In order to more accurately construct a baseline project based on your inputs, Corval can manage your project activities.</p>
                                 <p>Continue to let Corval Assistant help lay out your project and decide what items belong in it. Timing and dependencies will be managed for you.</p>
                             </>
                         ),
            actionLabel: props.isCorvalManaged ? null : 'Convert Project',
            active:      true,
            available:   true,
        } ],
        [ CorvalAssistantContextDecisionPointTypes.UNMANAGED, {
            title:       'Switch to Team-Managed Project',
            description: `Corval Assistant will only be used for recommendations and analysis.`,
            icon:        { name: 'users' },
            details:     (
                             <>
                                 <Header size={ 'small' }>Team-Managed Projects</Header>
                                 <p>This action will switch your project to a team-managed one - allowing timing, dependency, and resourcing decisions to be configured by your team. Versioning of projects are also enabled.</p>
                                 <p>Corval Assistant's functionality will scale back to allow users to decide what items belong in it, and will only be used to help compare or recommend project items.</p>
                             </>
                         ),
            actionLabel: props.isCorvalManaged ? 'Convert Project' : null,
            active:      true,
            available:   true,
        } ]
    ] );

    return (
        <DecisionPointDialog<CorvalAssistantContextDecisionPointTypes>
            { ...props }
            contentGridColumnWidth={ `35%` }
            dialogTitle={ `Corval Assistant Context` }
            decisionOptions={ CorvalAssistantContextGuidanceOptions }
        />
    );
}

export {
    CorvalAssistantContextUpdateDecisionPointDialog,
    CorvalAssistantContextUpdateDecisionPointDialogDefaultProps,
    type CorvalAssistantContextUpdateDecisionPointDialogProps,
};
